import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EthereumClient, w3mConnectors, w3mProvider } from "@web3modal/ethereum";
import { configureChains, createConfig, WagmiConfig, useAccount } from "wagmi";
import { Web3Modal } from "@web3modal/react";
import { useCookies } from 'react-cookie';
import { NETWORK } from "./config";

import './css/main.css';
import './css/wf-biofi.css';
import './css/remix.css';
import './css/biofi-front-end.css';

import Home from "./pages/Home";
import Login from "./pages/Login";
import DashboardOld from "./pages/DashboardOld";
import Dashboard from "./pages/Dashboard";
import BiofiStaking from "./pages/BiofiStaking";
import Stake from "./pages/Stake";
import StakeLP from "./pages/StakeLP";
import Learn from "./pages/Learn";
import Terms from "./pages/Terms";


let chains = [NETWORK];


const web3ModalProjectId = "63b3dbc5017e9b78758af2281a37c62b";

// Wagmi client
const { publicClient } = configureChains(chains, [
  w3mProvider({
    projectId: web3ModalProjectId
  }),
]);
const wagmiClient = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId: web3ModalProjectId, chains: chains }),
  publicClient
})

const ethereumClient = new EthereumClient(wagmiClient, chains);


function App() {
  //const { address } = useAccount();
  //let isWalletConnected = (address !== null && typeof (address) !== 'undefined');

  //const { setDefaultChain } = useWeb3Modal();
  //setDefaultChain(chains[0]);

  const [cookies] = useCookies(['userType']);
  let userType = cookies.userType;
  if (userType === undefined) {
    userType = "user";
  }

  return (
    <WagmiConfig config={wagmiClient}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route index element={<Home />} />
            <Route path="login" element={<Login validChain={chains[0]} />} />
            <Route path="dashboardOld" element={<DashboardOld validChain={chains[0]} />} />
            <Route path="dashboard" element={<Dashboard validChain={chains[0]} />} />
            <Route path="biofiRewards" element={<BiofiStaking validChain={chains[0]} />} />
            <Route path="deposit/:stakeId" element={<Stake validChain={chains[0]} />} />
            <Route path="deposit" element={<Navigate replace to="/biofiRewards" />} />
            <Route caseSensitive path="depositLp/:stakeId" element={<StakeLP validChain={chains[0]} />} />
            <Route path="depositLp" element={<Navigate replace to="/biofiRewards" />} />
            <Route path="learn" element={<Learn />} />
            <Route path="terms" element={<Terms />} />
            
            <Route path="stake/*" element={<Navigate replace to="/biofiRewards" />} />
            <Route path="stake" element={<Navigate replace to="/biofiRewards" />} />
            <Route path="biofiStaking" element={<Navigate replace to="/biofiRewards" />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </BrowserRouter>
      </div>
      <ToastContainer position="bottom-left" theme="dark" />

      <Web3Modal
        projectId={web3ModalProjectId}
        ethereumClient={ethereumClient}
        themeMode={"dark"}
        themeColor={"blackWhite"}
        themeVariables={
          { "--w3m-accent-color": "#344c85" }
        }
      />
    </WagmiConfig>
  );
}

export default App;
